import Register from './components/Register';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Home from './components/Home';
import Layout from './components/Layout';
import Editor from './components/Editor';
import Admin from './components/Admin';
import Missing from './components/Missing';
import Unauthorized from './components/Unauthorized';
import Recipes from './components/Recipes';
import ShoppingList from './components/ShoppingList';
import Billing from './components/Billing';

import LinkPage from './components/LinkPage';
import RequireAuth from './components/RequireAuth';
import PersistLogin from './components/PersistLogin';

import { Routes, Route } from 'react-router-dom';

import Map from './routes/googlemap';
import PCerie from './routes/pcpricecalc';
import WGMSjames from './routes/wgpricecalc';
import 'bootstrap/dist/css/bootstrap.min.css';

import Locationlock from './components/404';
import RecipesImagebuild from './components/RecipesImagebuild';
const ROLES = {
  'User': 2001,
  'Editor': 1984,
  'Admin': 5150,
  'DungeonMaster': 2020,
}

function App() {

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route element={<PersistLogin />}>
        {/* public routes */}
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="locationlock" element={<Locationlock />} />
        <Route path="linkpage" element={<LinkPage />} />
        <Route path="unauthorized" element={<Unauthorized />} />
        {/* we want to protect these routes */}
        
        <Route element={<RequireAuth allowedRoles={[ROLES.User]} />}>
              <Route path="recipes/:imglink" element={<RecipesImagebuild />} />
        </Route>

        
        <Route element={<RequireAuth allowedRoles={[ROLES.DungeonMaster, ROLES.Editor]} />}>
          <Route path="editor" element={<Editor />} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[ROLES.Admin, ROLES.DungeonMaster ]} />}>
          <Route path="admin" element={<Admin />} />
        </Route>
    
        <Route element={<RequireAuth allowedRoles={[ROLES.User]} />}>
          <Route path="/" element={<Home />} />
          <Route path="lounge" element={<Home />} />
          <Route path="recipes" element={<Recipes />} />
          <Route path="shopping-list" element={<ShoppingList />} />
          <Route path="billing" element={<Billing />} />

          <Route path="map" element={<Map />} />
          <Route path="pcerie" element={<PCerie />} />
          <Route path="wgmsjames" element={<WGMSjames />} />
        </Route>


        {/* catch all */}
        <Route path="*" element={<Missing />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default App;